module.exports = __webpack_public_path__ + "static/media/riskpic4.ab023c86.png";